<template>
  <v-row class="main-container">
    <dialog-shipment-information
      v-model="selectedShipmentId"
      :dialog="dialogShipmentInformation"
      :tab="shipmentInfoTab"
      v-on:dialog-close="onDialogClose"
    ></dialog-shipment-information>

    <dialog-manage-quotation
      v-if="dialogManageQuotation"
      :dialog="dialogManageQuotation"
      v-model="selectedQuotation"
      v-on:dialog-close="onDialogManageQuotationClose"
    ></dialog-manage-quotation>

    <!-- Dialog for managing booking files upload -->
    <dialog-file-cabinet
      v-model="selectedShipmentId"
      :company_id="selectedCompanyId"
      :dialog="dialogFileCabinet"
      :isBooking="true"
      v-on:dialog-close="onDialogClose"
    ></dialog-file-cabinet>

    <!-- Dialog for Comment Message Box -->
    <dialog-message-box
      :dialog="dialogMessageBox"
      v-model="selectedShipment"
      :title="messageBoxTitle"
      :quotation_id="messageBoxQuotationId"
      :invoice_id="messageBoxInvoiceId"
      :company_id="messageBoxCompanyId"
      :company_name="messageBoxCompanyName"
      :category="messageBoxCategory"
      :tags="messageBoxTags"
      v-on:dialog-close="onDialogClose"
    ></dialog-message-box>

    <!-- Dialog for email widget -->
    <dialog-email-widget
      :dialog="dialogEmailWidget"
      v-model="selectedShipment"
      :source="'booking'"
      :subject="emailRequestSubject"
      v-on:dialog-close="onDialogEmailClose"
    ></dialog-email-widget>

    <!-- warning dialog -->
    <v-dialog v-model="dialogOnCancelBooking" max-width="450">
      <v-card v-if="selected_booking != null" tile color="white" flat>
        <v-card-title class="dialog-header-title">Cancel Booking</v-card-title>
        <v-card-text class="mt-3">
          <v-alert tile outlined type="warning" dense prominent border="left">
            <span>
              Upon cancelling booking
              <strong>{{ selected_booking.shipment_order_id }}</strong
              >, you will lose the saved booking information and this can't be undone.
            </span>
            <br />
            <br />
            <span>Do you want to proceed?</span>
          </v-alert>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-row justify="end">
            <v-btn
              class="mx-2 font-weight-bold text-button"
              color="primary"
              depressed
              tile
              @click="cancelBooking"
              >YES</v-btn
            >
            <v-btn
              class="ml-2 font-weight-bold text-button"
              color="error"
              depressed
              tile
              @click="dialogOnCancelBooking = false"
              >NO</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End warning dialog -->

    <!-- Dialog filter booking list -->
    <v-dialog v-model="dialogFilterBooking" max-width="900">
      <v-card flat tile color="white">
        <v-card-title class="dialog-header-title">Filter booking list</v-card-title>

        <v-card-text class="py-1 px-1">
          <v-row>
            <v-col cols="2">
              <span>Shipment type:</span>
              <v-select
                class="form-control rounded-0"
                placeholder="type"
                :items="shipmentTypeFilters"
                solo
                v-model="selectedShipmentTypeFilter"
                clearable
                clear-icon="mdi-close"
              ></v-select>
            </v-col>

            <v-col>
              <span>Origin port:</span>
              <v-autocomplete
                class="form-control rounded-0"
                solo
                placeholder="Select origin port"
                :items="sortedPortList"
                item-text="label"
                item-value="un_code"
                clearable
                v-model="selectedOriginPortFilter"
              >
                <template v-slot:item="data">
                  <v-list-item-content style="font-size: 90%">
                    <v-list-item-title v-html="data.item.label"></v-list-item-title>
                  </v-list-item-content>
                </template>
                <template v-slot:item="data">
                  <img
                    :src="CONSTANT.getFlag(data.item.code_country)"
                    class="country-flag"
                  />
                  <v-list-item-content style="font-size: 90%">
                    <v-list-item-title v-html="data.item.label"></v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col>
              <span>Destination port:</span>
              <v-autocomplete
                class="form-control rounded-0"
                solo
                placeholder="Select destination port"
                :items="sortedPortList"
                item-text="label"
                item-value="un_code"
                clearable
                v-model="selectedDestPortFilter"
              >
                <template v-slot:item="data">
                  <v-list-item-content style="font-size: 90%">
                    <v-list-item-title v-html="data.item.label"></v-list-item-title>
                  </v-list-item-content>
                </template>
                <template v-slot:item="data">
                  <img
                    :src="CONSTANT.getFlag(data.item.code_country)"
                    class="country-flag"
                  />
                  <v-list-item-content style="font-size: 90%">
                    <v-list-item-title v-html="data.item.label"></v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>

          <v-row>
            <v-divider class="mt-3"></v-divider>
          </v-row>

          <v-row>
            <v-col class="mr-4">
              <span>Company:</span>
              <v-autocomplete
                v-if="$root.is_admin"
                class="form-control rounded-0"
                :items="sortedCompanies"
                placeholder="Select Company Name"
                return-object
                v-model="selectedCompany"
                clearable
                item-text="name"
                solo
              ></v-autocomplete>
            </v-col>

            <v-col cols="3">
              <span class="pt-2 mr-2 black--text">Filter by:</span>
              <v-select
                class="form-control rounded-0"
                placeholder="Select date filter"
                :items="dateRangeFilters"
                item-text="label"
                item-value="id"
                solo
                v-model="selectedDateRangeFilter"
                clearable
                clear-icon="mdi-close"
                style="width: 100%"
              ></v-select>
            </v-col>

            <v-col cols="2">
              <span class="pt-2 mr-2 black--text">Start date:</span>
              <flat-pickr
                v-model="selectedStartFilter"
                placeholder="Select date"
                :config="config"
                name="date"
              ></flat-pickr>
            </v-col>

            <v-col cols="2">
              <span class="pt-2 mr-2 black--text">End date:</span>
              <flat-pickr
                v-model="selectedEndFilter"
                placeholder="Select date"
                :config="config"
                name="date"
              ></flat-pickr>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider class="my-1"></v-divider>

        <v-card-actions>
          <v-row justify="end">
            <v-btn
              color="primary"
              small
              tile
              depressed
              class="font-weight-bold mr-2"
              @click="onLoadFilteredBookingList"
              >LOAD</v-btn
            >

            <v-btn
              color="error"
              small
              tile
              depressed
              class="font-weight-bold ml-2"
              @click="onCloseDialogBookingFilter"
              >CLOSE</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :top="true"
    >
      {{ snackbarMsg }}
      <v-btn dark text @click="showSnackbar = false">CLOSE</v-btn>
    </v-snackbar>

    <v-row no-gutters class="px-2">
      <v-col>
        <v-subheader class="headline pl-0 ml-0" style="color: #1976d2"
          >Bookings</v-subheader
        >
      </v-col>
    </v-row>

    <v-row>
      <v-divider class="mt-0"></v-divider>
    </v-row>

    <v-row dense>
      <v-col>
        <af-pagination
          v-model="pagination"
          v-on:next="onNextPage"
          v-on:prev="onPrevPage"
          v-on:rows-per-page-change="onitemsPerPageChange"
        ></af-pagination>
      </v-col>

      <v-col cols="1" class="pr-2">
        <v-row justify="end">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon small class="mr-2" @click="onOpenDialogFilterBooking">
                <v-icon size="30" color="primary">{{
                  isResetFilter ? "mdi-filter-menu-outline" : "mdi-filter-menu"
                }}</v-icon>
              </v-btn>
            </template>
            Filter booking list
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                small
                tile
                depressed
                icon
                color="primary"
                @click="onResetRefreshBookingList"
              >
                <v-icon size="30">mdi-refresh</v-icon>
              </v-btn>
            </template>
            Reset filter
          </v-tooltip>
        </v-row>
      </v-col>
    </v-row>

    <v-row>
      <v-divider class="mt-1"></v-divider>
    </v-row>

    <v-row no-gutters class="pa-2">
      <v-col cols="12" v-if="!empty_booking_list">
        <template v-for="(item, i) in bookingsTableView">
          <v-row
            :key="i"
            no-gutters
            v-if="item.status < CONSTANT.STATUS.SHIPMENT_ORDER.BOOKING_CONFIRMED"
          >
            <v-col>
              <v-card color="white" tile class="elevation-3">
                <v-card-text class="pb-0 pt-1 pr-0">
                  <v-row no-gutters class="pb-2">
                    <v-col cols="10">
                      <v-row no-gutters>
                        <span class="font-weight-bold caption black--text mr-4">
                          <v-icon size="20" color="primary">
                            {{ getShipmentType(item).icon }}
                          </v-icon>
                          {{ item.shipment_order_id }}
                        </span>
                        <v-chip
                          x-small
                          class="pa-1 mt-1 mr-2 font-weight-bold overline"
                          label
                          outlined
                          :color="getTransactionType(item).color"
                          >{{ getTransactionType(item).title }}</v-chip
                        >

                        <v-chip
                          x-small
                          class="pa-1 mt-1 mx-2 font-weight-bold overline"
                          label
                          outlined
                          >{{ getShipmentType(item).title }}</v-chip
                        >

                        <v-chip
                          x-small
                          class="pa-1 mt-1 mx-2 font-weight-bold overline"
                          label
                          outlined
                          >{{ item.quotation.incoterm }}</v-chip
                        >

                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-chip
                              class="pa-2 mt-1 mx-2 font-weight-bold overline"
                              outlined
                              label
                              x-small
                              v-on="on"
                            >
                              <v-icon
                                x-small
                                :color="getCargoType(item).color"
                                size="15"
                                left
                                >{{ getCargoType(item).icon }}</v-icon
                              >
                              {{ item.quotation.cargo_type_code }}
                            </v-chip>
                          </template>
                          <span>{{ getCargoType(item).title }}</span>
                        </v-tooltip>

                        <v-tooltip right>
                          <template v-slot:activator="{ on }">
                            <span
                              v-on="on"
                              class="font-weight-bold overline grey--text text--darken-4 mt-1 ml-4"
                            >
                              <v-icon size="10" left color="primary" class="mr-0"
                                >mdi-checkbox-blank-circle</v-icon
                              >
                              {{
                                `${item.quotation.origin_port.name}, ${item.quotation.origin_port.un_code}`
                              }}
                            </span>
                          </template>
                          {{ item.quotation.origin_port.country }}
                        </v-tooltip>

                        <span class="mx-1">----</span>

                        <v-tooltip right>
                          <template v-slot:activator="{ on }">
                            <span
                              v-on="on"
                              class="font-weight-bold overline grey--text text--darken-4 mt-1"
                            >
                              <v-icon size="10" left color="error" class="mr-0"
                                >mdi-checkbox-blank-circle</v-icon
                              >
                              {{
                                `${item.quotation.destination_port.name}, ${item.quotation.destination_port.un_code}`
                              }}
                            </span>
                          </template>
                          {{ item.quotation.destination_port.country }}
                        </v-tooltip>
                      </v-row>
                    </v-col>

                    <v-col class="d-flex justify-content-end pr-2">
                      <v-tooltip left>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            x-small
                            icon
                            color="error"
                            class="font-weight-bold pl-1"
                            @click="onCancelBooking(item)"
                          >
                            <v-icon size="25">mdi-cancel</v-icon>
                          </v-btn>
                        </template>
                        <span>Cancel booking</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>

                  <v-row no-gutters class="mt-2">
                    <v-col cols="6">
                      <v-row justify="start">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-on="on"
                              x-small
                              text
                              color="primary"
                              class="font-weight-bold pl-1"
                              @click="onShipmentInfoDialog(item)"
                            >
                              <v-icon size="20" left class="mr-1">mdi-tune</v-icon
                              >Shipment Info
                            </v-btn>
                          </template>
                          Manage shipment information
                        </v-tooltip>

                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-if="$root.is_admin"
                              v-on="on"
                              x-small
                              text
                              color="primary"
                              class="font-weight-bold pl-1"
                              @click="
                                onBookingQuotationDialog(
                                  item,
                                  CONSTANT.DIALOG_MANAGE_QUOTATION
                                )
                              "
                            >
                              <v-icon size="20" left class="mr-1"
                                >mdi-square-edit-outline</v-icon
                              >Quotation
                            </v-btn>
                          </template>
                          Edit quotation information
                        </v-tooltip>

                        <!-- <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-if="$root.is_admin"
                              v-on="on"
                              x-small
                              text
                              color="primary"
                              class="font-weight-bold pl-1"
                              @click="openEmailDialog(item)"
                            >
                              <v-icon size="20" left class="mr-1">mdi-email</v-icon>Email
                            </v-btn>
                          </template>
                          Send an email
                        </v-tooltip> -->

                        <shipment-files-count
                          :shipment_order_id="item.shipment_order_id"
                          :company_id="item.company.company_id"
                          v-on:open-shipment-file-dialog="onUploadBookingDocs"
                        ></shipment-files-count>

                        <template v-if="$root.is_admin">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-badge
                                class="font-weight-bold"
                                :content="message_count[item.quotation_id]"
                                :value="message_count[item.quotation_id]"
                                color="amber darken-4"
                                overlap
                                bordered
                                offset-x="9"
                                offset-y="10"
                              >
                                <v-btn
                                  v-on="on"
                                  x-small
                                  icon
                                  @click="onViewMessages(item)"
                                >
                                  <v-icon size="22" color="primary"
                                    >mdi-message-text</v-icon
                                  >
                                </v-btn>
                              </v-badge>
                            </template>
                            View and post comments
                          </v-tooltip>
                        </template>
                      </v-row>
                    </v-col>

                    <v-col cols="2" class="mt-1">
                      <span class="overline black--text mr-2">
                        <span class="font-weight-black">CRD:</span>
                        {{ item.quotation.crd_string }}
                      </span>
                    </v-col>

                    <v-col v-if="$root.is_admin" class="mt-1">
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <span
                            v-on="on"
                            class="font-weight-bold caption grey--text text--darken-4 text-uppercase mr-4"
                            >{{ item.company.short_name }}</span
                          >
                        </template>
                        {{ item.company.name }}
                      </v-tooltip>
                    </v-col>

                    <v-col v-if="$root.is_admin" cols="2" class="d-flex justify-end pb-1">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            small
                            outlined
                            tile
                            color="green darken-3"
                            class="font-weight-bold text-uppercase caption px-2 mr-2"
                            @click="onBookingConfirm(item)"
                          >
                            <v-icon left size="20" class="mr-1">mdi-file-check</v-icon
                            >Complete Booking
                          </v-btn>
                        </template>
                        Click to complete booking process
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-divider :key="`${i}divider`"></v-divider>
        </template>
      </v-col>

      <v-col v-else class="mt-10 pa-10">
        <v-alert tile dense prominent type="error">
          <v-row align="center">
            <v-col v-if="selectedCompany != null" class="grow">
              <strong>{{ selectedCompany.name }}</strong> does not have any to be
              confirmed Booking at the moment
            </v-col>
            <v-col v-else class="grow">Booking list is empty</v-col>
          </v-row>
        </v-alert>
      </v-col>
    </v-row>
  </v-row>
</template>

<script>
import constant from "../../const";
import moment from "moment";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "flatpickr/dist/themes/airbnb.css";
import DialogShipmentInformation from "@/components/user/DialogShipmentInformation";
import DialogManageQuotation from "@/components/admin/dialogs/DialogManageQuotation";
import DialogFileCabinet from "@/components/user/DialogFileCabinet.vue";
import DialogEmailWidget from "@/components/admin/dialogs/DialogEmailWidget.vue";
import DialogMessageBox from "@/components/user/DialogMessageBox.vue";
import ShipmentFilesCount from "@/components/shared/ShipmentFilesCount.vue";
import AFPagination from "@/components/shared/AFPagination";

export default {
  components: {
    flatPickr,
    DialogShipmentInformation,
    DialogManageQuotation,
    DialogFileCabinet,
    DialogEmailWidget,
    DialogMessageBox,
    ShipmentFilesCount,
    "af-pagination": AFPagination,
  },

  data() {
    return {
      CONSTANT: constant,
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 6000,
      alert: false,
      alertType: "success",
      alertMessage: "",

      config: {
        altInput: true,
        altInputClass: "flatpickr-alt-input-filter",
        // enableTime: true,
        altFormat: "M j, Y",
        dateFormat: "Y-m-d",
        // time_24hr: true,
        position: "auto",
      },

      // dialogs
      dialogOnCancelBooking: false,
      dialogShipmentInformation: false,
      shipmentInfoTab: null,
      dialogFileCabinet: false,
      dialogManageQuotation: false,
      dialogEmailWidget: false,
      dialogFilterBooking: false,

      emailRequestSubject: null,

      dialogMessageBox: false,
      messageBoxTitle: null,
      messageBoxQuotationId: null,
      messageBoxInvoiceId: null,
      messageBoxCompanyId: null,
      messageBoxCompanyName: null,
      messageBoxCategory: "shipment",
      messageBoxTags: [],

      message_count: {},

      // dialog v-models
      selectedShipmentId: null,
      selectedCompanyId: null,
      selectedShipment: null,
      selectedShipmentSync: {},
      selectedQuotation: null,
      selected_booking: null,

      selectedCompany: null,
      companies: [],

      pagination: {
        sortBy: ["shipment_order_id"],
        sortDesc: [true],
        page: 1,
        itemsPerPage: 20,
        totalItems: 0,
      },

      bookings: [],
      bookingsTableView: [],
      empty_booking_list: false,

      shipmentTypeFilters: ["FCL", "LCL", "AIR"],
      dateRangeFilters: [
        {
          id: 0,
          label: "Cargo ready date",
        },
        {
          id: 1,
          label: "Booking created date",
        },
      ],
      portList: [],

      selectedShipmentTypeFilter: null,

      selectedOriginPortFilter: null,
      selectedDestPortFilter: null,

      selectedDateRangeFilter: null,

      selectedStartFilter: null,
      selectedEndFilter: null,

      isResetFilter: true,
    };
  },

  async created() {
    this.$root.fullScreenView = false;
    this.$root.blockUImsg = "Loading bookings";
    this.$root.blockUIshow = true;
    // verify user token
    await this.$root.verify_user_token();

    this.initializeFilters();
    this.initializeBookingsList(false);
  },
  mounted() {},

  watch: {},

  methods: {
    /**
     * fetch ports
     */
    async fetch_ports() {
      let resp = await this.$https.get("/api/ports");
      this.portList = resp.data.data || [];
    },

    /**
     * Load companies
     */
    async loadCompanies() {
      if (this.$root.is_admin) {
        let resp = await this.$https.get("/api/company/list");
        this.companies = resp.data.data || [];
      }
    },

    /**
     * Initialise the filters
     */
    async initializeFilters() {
      this.loadCompanies();
      this.fetch_ports();

      this.selectedStartFilter = moment().startOf("month").format("YYYY-MM-DD"); // default to start of the current month
      this.selectedEndFilter = moment().endOf("month").format("YYYY-MM-DD"); // default to end of the current month
    },

    /**
     * Reset the filters
     */
    resetFilters() {
      this.selectedCompany = null;
      this.selectedShipmentStatusFilter = 1;

      this.selectedShipmentTypeFilter = null;

      this.selectedOriginPortFilter = null;
      this.selectedDestPortFilter = null;

      this.selectedDateRangeFilter = null;

      this.selectedStartFilter = null;
      this.selectedEndFilter = null;

      this.isResetFilter = true;
    },

    /**
     * On reset filters and refresh booking list
     */
    onResetRefreshBookingList() {
      this.resetFilters();
      this.initializeBookingsList(false);
    },

    /**
     * Refresh booking view list
     */
    refreshBookingsViewList() {
      this.bookingsTableView = this.bookings.slice(
        (this.pagination.page - 1) * this.pagination.itemsPerPage,
        this.pagination.page * this.pagination.itemsPerPage
      );
    },

    /**
     * on open dialog filter booking list
     */
    onOpenDialogFilterBooking() {
      this.dialogFilterBooking = true;
    },

    /**
     * load the booking list
     */
    initializeBookingsList(isAppend) {
      this.$root.blockUImsg = "Loading bookings";
      this.$root.blockUIshow = true;

      let requestString = `/api/shipment_orders/list?limit=${
        this.pagination.itemsPerPage
      }&booking_process=${true}`;

      if (this.selectedCompany != null) {
        requestString = requestString + "&company_id=" + this.selectedCompany.company_id;
      }

      if (isAppend && this.pagination.next_cursor != null) {
        requestString = requestString + "&cursor=" + this.pagination.next_cursor;
      } else {
        this.bookings = [];
        this.pagination.totalItems = 0;
        this.pagination.next_cursor = null;
        this.pagination.page = 1;
      }

      // append the advanced filters
      // if shipment type filter selected
      if (this.selectedShipmentTypeFilter != null) {
        requestString = `${requestString}&s_type=${this.selectedShipmentTypeFilter}`;
      }

      // if origin port filter selected
      if (this.selectedOriginPortFilter != null) {
        requestString = `${requestString}&op_un_code=${this.selectedOriginPortFilter}`;
      }

      // if destination port filter selected
      if (this.selectedDestPortFilter != null) {
        requestString = `${requestString}&dp_un_code=${this.selectedDestPortFilter}`;
      }

      // iif date range filter is not null
      if (this.selectedDateRangeFilter != null) {
        // validate start and end date
        if (
          this.selectedStartFilter == null ||
          this.selectedEndFilter == null ||
          this.selectedStartFilter.length == 0 ||
          this.selectedEndFilter.length == 0
        ) {
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = "Invalid input for either start or end date";
          this.$root.blockUIshow = false;
          return;
        }

        if (this.selectedDateRangeFilter == 0) {
          requestString = `${requestString}&filter_by_crd=true&start_crd=${this.selectedStartFilter}&end_crd=${this.selectedEndFilter}`;
        } else if (this.selectedDateRangeFilter == 1) {
          requestString = `${requestString}&filter_by_created=true&start_crd=${this.selectedStartFilter}&end_crd=${this.selectedEndFilter}`;
        }
      }

      this.$https
        .get(requestString)
        .then((resp) => {
          var response = resp.data;
          if (response.status == constant.RESPONSE_STATUS_OK) {
            this.empty_booking_list = false;

            // initialise the message count object
            response.data.data.forEach((element) => {
              this.$set(this.message_count, element.shipment_order_id, 0);
            });

            this.bookings.push(...response.data.data);
            if (response.data.count > 0) {
              this.pagination.totalItems = response.data.count;
            }

            this.pagination.next_cursor = response.data.next_cursor;

            this.refreshBookingsViewList();
            this.$root.blockUIshow = false;

            // set the comment messages for each quotation
            const firestore_db = this.$root.messageCenterApp.firestore();
            response.data.data.forEach((element) => {
              this.setMessageCount(firestore_db, element);
            });
          } else if (response.status == constant.RESPONSE_STATUS_EMPTY) {
            this.empty_booking_list = true;
            this.$root.blockUIshow = false;
          } else {
            console.log("Error loading bookings list", response);
            this.showSnackbar = true;
            this.snackbarColor = "error";
            this.snackbarMsg = response.msg;
            this.$root.blockUIshow = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = err;
          this.$root.blockUIshow = false;
        });
    },

    // Pagination methods

    onNextPage() {
      let isLastPageLoaded =
        this.pagination.itemsPerPage * (this.pagination.page - 1) == this.bookings.length;

      if (isLastPageLoaded) {
        this.initializeBookingsList(true);
      } else {
        this.refreshBookingsViewList();
      }
    },

    onPrevPage() {
      this.refreshBookingsViewList();
    },

    onitemsPerPageChange() {
      this.initializeBookingsList(false);
    },

    // End pagination methods

    /**
     * Get the shipment type
     * @param {object} shipment
     */
    getShipmentType(shipment) {
      var color = "error";
      var title = "";
      var icon = "mdi-alert-circle";

      switch (shipment.quotation_type) {
        case constant.QUOTATION_TYPE_SEA_FCL:
          color = "light-blue darken-4";
          title = "FCL";
          icon = "mdi-ferry";
          break;
        case constant.QUOTATION_TYPE_SEA_LCL:
          color = "accent";
          title = "LCL";
          icon = "mdi-ferry";
          break;
        case constant.QUOTATION_TYPE_AIR:
          color = "secondary";
          title = "AIR";
          icon = "mdi-airplane-takeoff";
          break;
        case constant.QUOTATION_TYPE_WAREHOUSE:
          color = "blue-grey";
          title = "WH";
          icon = "mdi-warehouse";
          break;
        default:
          break;
      }

      return { icon: icon, color: color, title: title };
    },

    /**
     * Get the transaction type
     * @param {object} shipment
     */
    getTransactionType(shipment) {
      var color = "";
      var title = "";

      if (shipment.quotation.transaction_type == "EXPORT") {
        color = "#8F2D56";
        title = "EXP";
      } else if (shipment.quotation.transaction_type == "IMPORT") {
        color = "#3CAEA3";
        title = "IMP";
      }

      return { color: color, title: title };
    },

    /**
     * Get the cargo type
     * @param {object} shipment
     */
    getCargoType(shipment) {
      var color = "brown";
      var title = "";
      var icon = "fa-box";

      switch (shipment.quotation.cargo_type_code) {
        case "DG-2":
          title = shipment.quotation.cargo_type_code + ": Gases";
          color = "deep-orange lighten-1";
          icon = "fa-burn";
          break;
        case "DG-3":
          title = shipment.quotation.cargo_type_code + ": Flammable liquids";
          color = "error";
          icon = "fa-fire";
          break;
        case "NON-DG":
          title = shipment.quotation.cargo_type_code + ": Non dangerous goods";
          color = "brown lighten-1";
          break;
      }

      return { icon: icon, color: color, title: title };
    },

    /**
     * on upload documents for booking
     */
    onUploadBookingDocs(shipment_order_id, company_id) {
      this.selectedShipmentId = shipment_order_id;
      this.selectedCompanyId = company_id;

      this.dialogFileCabinet = true;
    },

    /** On cancel booking */
    onCancelBooking(booking) {
      this.selected_booking = booking;
      this.dialogOnCancelBooking = true;
    },

    /** Cancel Booking */
    async cancelBooking() {
      this.$root.blockUImsg = "Cancelling booking";
      this.$root.blockUIshow = true;

      let resp = await this.$https.put(
        `/api/quotations/${this.selected_booking.shipment_order_id}/booking_cancelled`
      );
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        this.showSnackbar = true;
        this.snackbarColor = "success";
        this.snackbarMsg = resp.data.msg;

        // remove booking
        this.bookings = this.bookings.filter((item) => {
          return item != this.selected_booking;
        });
        this.refreshBookingsViewList();

        this.selected_booking = null;
        this.dialogOnCancelBooking = false;
      } else {
        console.log(resp.data);
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = resp.data.msg;
      }

      this.$root.blockUIshow = false;
    },

    /**
     *  on confirming booking
     */
    onBookingConfirm(booking) {
      this.$root.blockUImsg = "Confirming booking";
      this.$root.blockUIshow = true;
      var response = null;

      this.$https
        .put(`/api/shipment_orders/${booking.shipment_order_id}/booking_confirmed`)
        .then((resp) => (response = resp.data))
        .catch((err) => {
          console.log(err);
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = err;
        })
        .finally(() => {
          if (response.status == constant.RESPONSE_STATUS_OK) {
            // update the booking status
            booking.status = constant.STATUS.SHIPMENT_ORDER.BOOKING_CONFIRMED;
            this.showSnackbar = true;
            this.snackbarColor = "success";
            this.snackbarMsg = response.msg;
          } else {
            console.log(response);
            this.showSnackbar = true;
            this.snackbarColor = "error";
            this.snackbarMsg = response.msg;
          }
          this.$root.blockUIshow = false;
        });
    },

    /**
     * On open shipment information dialog
     */
    onShipmentInfoDialog(booking) {
      this.selectedShipmentId = booking.shipment_order_id;
      this.shipmentInfoTab = 1;
      // clone the selected booking
      this.selectedShipmentSync = booking;
      this.dialogShipmentInformation = true;
    },

    /**
     * On open quotation relate dialogs
     */
    onBookingQuotationDialog(booking, dialog) {
      this.$root.blockUImsg = "Loading quotation information";
      this.$root.blockUIshow = true;
      var response = null;

      this.$https
        .get("/api/quotations/" + booking.shipment_order_id)
        .then((resp) => (response = resp.data))
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          if (response.status == constant.RESPONSE_STATUS_OK) {
            this.selectedQuotation = response.data;

            switch (dialog) {
              case constant.DIALOG_MANAGE_QUOTATION:
                this.dialogManageQuotation = true;
                break;
            }
          }

          this.$root.blockUIshow = false;
        });
    },

    /**
     * Check for missing booking files
     */
    checkForMissingBookingFiles(docs) {
      var status = false;
      for (let i = 0; i < docs.length; i++) {
        const element = docs[i];
        // if uploaded is false, then one file is missing
        if (!element.uploaded) {
          status = true;
          break;
        }
      }
      return status;
    },

    /**
     * On Send email
     */
    openEmailDialog(booking) {
      this.selectedShipment = booking;
      this.emailRequestSubject = `[${booking.shipment_order_id}] Booking Request`;
      this.dialogEmailWidget = true;
    },

    /**
     * Set the comment message count for each shipment
     */
    setMessageCount(firestore_db, booking) {
      // Get the message count and listen to the document
      firestore_db
        .collection("comments")
        .doc(booking.shipment_order_id)
        .onSnapshot((doc) => {
          if (!doc.exists) {
            this.message_count[booking.shipment_order_id] = 0;
            // console.error("doc doesnt exist");
          } else {
            // get the message count number
            this.message_count[booking.shipment_order_id] = doc.data().count;
          }
        });
    },

    /**
     * On open the message box
     */
    onViewMessages(booking) {
      this.messageBoxTitle = `Shipment ${booking.shipment_order_id}`;
      this.messageBoxQuotationId = booking.shipment_order_id;
      this.messageBoxInvoiceId = null;
      this.messageBoxCompanyId = booking.company.company_id;
      this.messageBoxCompanyName = booking.company.name;
      this.messageBoxTags = [
        `${booking.quotation_type.toLowerCase()}`,
        `${booking.quotation.transaction_type.toLowerCase()}`,
        `${booking.quotation.incoterm.toLowerCase()}`,
        `${booking.quotation.cargo_type_code.toLowerCase()}`,
      ];
      this.dialogMessageBox = true;
    },

    /**
     * On close Dialog Manage Quotation
     */
    onDialogManageQuotationClose(
      quotation,
      hasChange,
      isReAssigned = false,
      newCompany = null
    ) {
      this.dialogManageQuotation = false;
      this.selectedQuotation = null;
      this.selectedShipment = null;
    },

    /**
     * on load filtered booking list
     */
    onLoadFilteredBookingList() {
      this.isResetFilter = false;
      this.dialogFilterBooking = false;
      this.initializeBookingsList(false);
    },

    /**
     * on close the dialog booking list filter
     */
    onCloseDialogBookingFilter() {
      this.dialogFilterBooking = false;
    },

    /**
     * on close the dialogs
     */
    onDialogClose(dialogID, object, hasChange) {
      switch (dialogID) {
        case constant.DIALOG_SHIPMENT_INFORMARTION:
          this.dialogShipmentInformation = false;
          this.shipmentInfoTab = null;
          // sync only if hasChange is true
          if (hasChange) {
            // sync the updated booking
            this.selectedShipmentSync = Object.assign(this.selectedShipmentSync, object);
          }
          break;
        case constant.DIALOG_FILE_CABINET:
          this.dialogFileCabinet = false;
          break;
        case constant.DIALOG_MESSAGE_BOX:
          this.dialogMessageBox = false;
          this.messageBoxTitle = null;
          this.messageBoxQuotationId = null;
          this.messageBoxInvoiceId = null;
          this.messageBoxCompanyId = null;
          this.messageBoxCompanyName = null;
          this.messageBoxTags = null;
          break;
      }

      this.selectedQuotation = null;
      this.selectedShipment = null;
      this.selectedShipmentId = null;
      this.selectedCompanyId = null;
    },

    onDialogEmailClose() {
      this.dialogEmailWidget = false;
      this.selectedShipment = null;
    },
  },

  computed: {
    sortedCompanies: function () {
      return this.companies.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    },

    sortedPortList: function () {
      return this.portList.sort(function (a, b) {
        return a.label.localeCompare(b.label);
      });
    },
  },
};
</script>

<style scoped>
/* input[type="checkbox"].custom-control-input {
  width: 30px;
  height: 30px;
} */

::v-deep .v-stepper__step__step {
  width: 25px;
  height: 25px;
  border-radius: 100%;
}
</style>
